import request from '@/utils/request.js';

// 账单明细
export const listBillOrder = (pageData, formData) => {
  return request.post(`/admin/bill/page/${pageData.page}/${pageData.pageSize}`, formData)
}